module.exports = __webpack_public_path__ + "img/star_wars_logo.5d100186.png";